import { EmployeesSection } from '@/features/employees';

interface MitarbeiterTabProps {
  companyId: string;
}

export function MitarbeiterTab({ companyId }: MitarbeiterTabProps) {
  return (
    <div className="space-y-4 flex-1 min-h-0 flex flex-col w-full h-full">
      <EmployeesSection companyId={companyId} />
    </div>
  );
}
